import HeadphonesRoundedIcon from '@mui/icons-material/HeadphonesRounded';
import { Box, Stack, Typography } from '@mui/material';
import { ListenRepeatExercise } from '../../mockLessonContent';
import { BLUE, cardSx, INTER, NAVY, POPPINS, SLATE, SURFACE_SOFT } from '../../studentStyles';
import AudioPlayButton from '../AudioPlayButton';
import RecordAnswerPanel from './RecordAnswerPanel';
import SpeakingHero from './SpeakingHero';

interface ListenRepeatExerciseCardProps {
    exercise: ListenRepeatExercise;
    onReady: () => void;
}

// "Dialog w/ Listen & Speak" and its ungraded twin. Unlike the speaking prompt,
// the target sentence is handed to the student — this is imitation, not
// production — so it leads the card instead of being withheld.
export default function ListenRepeatExerciseCard({ exercise, onReady }: ListenRepeatExerciseCardProps) {
    return (
        <Box sx={{ ...cardSx, overflow: 'hidden' }}>
            <SpeakingHero
                label={exercise.graded ? 'LISTEN & REPEAT' : 'LISTEN & REPEAT · NOT SCORED'}
                hanzi={exercise.hanzi}
                pinyin={exercise.pinyin}
            />

            <Box sx={{ p: 2.5 }}>
                {/* Model audio: play it as often as you like before answering */}
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <Box sx={{
                        width: 42, height: 42, borderRadius: '14px', flexShrink: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: `${BLUE}1A`,
                    }}>
                        <HeadphonesRoundedIcon sx={{ color: BLUE }} />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 16, color: NAVY }}>
                            Model audio
                        </Typography>
                        <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE }}>
                            Play it as often as you like
                        </Typography>
                    </Box>
                    <AudioPlayButton ariaLabel={`Play audio for ${exercise.hanzi}`} size={40} />
                </Stack>

                <Box sx={{ mt: 2.5, p: 2.25, borderRadius: '16px', backgroundColor: SURFACE_SOFT }}>
                    <Typography sx={{ fontFamily: INTER, fontSize: 14, color: NAVY }}>
                        {exercise.english}
                    </Typography>
                    <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, mt: 0.75 }}>
                        {exercise.infoText}
                    </Typography>
                </Box>

                <RecordAnswerPanel
                    grades={exercise.grades}
                    graded={exercise.graded}
                    idleLabel="Hold to repeat"
                    onScored={onReady}
                />
            </Box>
        </Box>
    );
}
